import React, { useState } from 'react';

// components
import { Button, Card, CardBody, FormGroup, Input, Row, Col } from "reactstrap";
import InputResposta from "../../../components/Inputs/InputResposta";

// helpers
import { showMessage } from "../../../helpers/message.js";

export default function VistoriaOnlineQuestionario({ formularioVistoria, handleFinalizarQuestionario }) {

    const [showFinalizar, set_showFinalizar] = useState(false);

    const [questaoAtual, set_questaoAtual] = useState(formularioVistoria.questoes[0]);
    const [valorQuestao, set_valorQuestao] = useState(null);

    const [questoesExecutadas, set_questoesExecutadas] = useState([]);
    const [questoesPendentes, set_questoesPendentes] = useState(formularioVistoria.questoes);

    const handlePressConfirmarQuestao = () => {

        // Grava a questão atual na lista de questões executadas
        let _questoesExecutadas = questoesExecutadas;
        let _questoesPendentes = questoesPendentes;

        if (questaoAtual) {
            if (!valorQuestao && questaoAtual.obrigatorio) {
                showMessage("Aviso", "Responda a pergunta antes de confirmar", 'error', null);
                return;
            }

            _questoesExecutadas.push({
                formularioVistoriaQuestao_Id: questaoAtual.formularioVistoriaQuestao_Id,
                identificacao: questaoAtual.identificacao,
                valor: valorQuestao,
                penalidade: false
            });
            set_questoesExecutadas(_questoesExecutadas);

            _questoesPendentes = questoesPendentes.filter(f => f.formularioVistoriaQuestao_Id != questaoAtual.formularioVistoriaQuestao_Id);
            set_questoesPendentes(_questoesPendentes);
        }

        let _proximaQuestao = null;

        // Percorre a lista de questões, para localizar a próxima a ser executada
        for (var i in _questoesPendentes) {
            if (_questoesPendentes[i].possuiDependencia && _questoesPendentes[i].questaoDependente) {
                if (_questoesExecutadas.filter(f => f.formularioVistoriaQuestao_Id == _questoesPendentes[i].questaoDependente.questaoPai_Id
                    && f.valor == _questoesPendentes[i].questaoDependente.questaoPai_Valor).length > 0) {
                    _proximaQuestao = _questoesPendentes[i];
                    break;
                }
            }
            else {
                _proximaQuestao = _questoesPendentes[i];
                break;
            }
        }

        set_valorQuestao(null);
        set_questaoAtual(_proximaQuestao);

        // Se não tiver nenhuma questão para responder, permite encerrar a inspeção
        if (!_proximaQuestao)
            set_showFinalizar(true);
    }

    const handlePressFinalizar = () => {
        handleFinalizarQuestionario(questoesExecutadas);
    }

    return (
        <>
            <Card className="mt-4">
                <CardBody>
                    <h5 className="subtitleCard">Lista de Questões</h5>
                    <Row className="align-items-end">
                        {questoesExecutadas.map((m, key) => (
                            <Col lg="12" md="12" sm="12" key={key}>
                                <FormGroup>
                                    <label className="form-control-label"><i className={m.valor ? "fas fa-check text-success" : "fas fa-times text-danger"}></i> {m.identificacao}</label>
                                    <Input className="form-control"
                                        autocomplete="off"
                                        type="text"
                                        name="texto"
                                        disabled={true}
                                        value={m.valor}
                                    />
                                </FormGroup>
                            </Col>
                        ))}
                        {questaoAtual &&
                            <Col lg="12" md="12" sm="12" key={questaoAtual.formularioVistoriaQuestao_Id}>
                                <InputResposta
                                    id={questaoAtual.formularioVistoriaQuestao_Id}
                                    typeInput={questaoAtual.tipoValor}
                                    label={questaoAtual.identificacao}
                                    obrigatorio={questaoAtual.obrigatorio}
                                    listaOpcoes={questaoAtual.opcoesResposta}
                                    handleChangeValor={(id, value) => set_valorQuestao(value)}>
                                </InputResposta>
                            </Col>
                        }
                    </Row>
                    {!showFinalizar &&
                        <Row>
                            <Col lg="12" md="12" sm="12" className="text-center">
                                <Button color="info" type="button" onClick={handlePressConfirmarQuestao}>
                                    Próxima Questão
                                </Button>
                            </Col>
                        </Row>
                    }
                    {showFinalizar &&
                        <Row>
                            <Col lg="12" md="12" sm="12" className="text-center">
                                <Button color="success" type="button" onClick={handlePressFinalizar}>
                                    Finalizar Inspeção
                                </Button>
                            </Col>
                        </Row>
                    }
                </CardBody>
            </Card>
        </>
    );
}

